import {
  fallback,
  zodValidator,
} from '@tanstack/zod-adapter';
import {
  type JwtPayload,
} from 'jwt-decode';
import {
  z,
} from 'zod';

export interface DecodedInviteToken extends JwtPayload {
  compName: string;
  username: string;
  role: string;
}

export const inviteTokenSearchSchema = z.object({
  token: fallback(z.string(), '').optional(),
});

export type InviteTokenSearch = z.infer<typeof inviteTokenSearchSchema>;
export const inviteTokenValidator = zodValidator(inviteTokenSearchSchema);

export default inviteTokenValidator;
